import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="accordion"
export default class extends Controller {
	static targets = ["icon", "title", "body", "trigger"];
	static values = { open: Boolean };

	connect() {
		this.load();
	}

	toggle(event) {
		if (this.isIgnored(event.target)) return;

		this.openValue = !this.openValue;
		this.load();
	}

	load() {
		if (this.openValue) this.open();
		else this.close();
	}

	open() {
		this.iconTargets.forEach((icon) => {
			icon.classList.add("rotate-180");
		});
		this.bodyTargets.forEach((body) => {
			body.classList.remove("hidden");
		});
		this.triggerTargets.forEach((trigger) => {
			trigger.setAttribute("aria-expanded", "true");
		});
		this.openValue = true;
	}

	close() {
		this.iconTargets.forEach((icon) => {
			icon.classList.remove("rotate-180");
		});
		this.bodyTargets.forEach((body) => {
			body.classList.add("hidden");
		});
		this.triggerTargets.forEach((trigger) => {
			trigger.setAttribute("aria-expanded", "false");
		});
		this.openValue = false;
	}

	// Ignores clicks on any element inside a data-accordion-ignore subtree
	isIgnored(target) {
		return target?.closest?.("[data-accordion-ignore]");
	}
}
